import React from "react";
import {Icon, styled, Tooltip} from "@reside/ui";

export const AlertIcon = styled(Icon)`
  color: ${({theme}) => theme.color.orange100};
`;

const StyledTooltip = styled(Tooltip)`
  cursor: default;
`;

export const PacketSizeLimitAlertIcon = () => (
  <StyledTooltip content="Packet size limit exceeded">
    <AlertIcon name="alert" />
  </StyledTooltip>
);
